import React, { Component, useEffect } from "react";
import MetaTags from 'react-meta-tags';

import {
  Header,
  ButtonScroll,
  DetailsBanner,
  ContentPicture,
  Navbar,
  SectionCareer,
  ContentSidePicture,
  ContentPictureText,
  ContentMain,
  MapView
} from "../../components";

import style from "./ProjectDetails.module.scss";
import { useDispatch, useSelector } from 'react-redux';
import useLocale from "../../hooks/useLocale";
import { loadProjectBySlug, loadProjectsData } from "../../store/slices/projects";
import { normalizeMedia } from "../../api/strapi";

function HookWrapper({ slug, render }) {
  const locale = useLocale();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadProjectBySlug(slug, locale));
    // List needed for prev/next adjacency on cold/bookmarked visits.
    dispatch(loadProjectsData(locale));
  }, [dispatch, slug, locale]);

  return render(loadDetail(slug), loadGlossary(), locale);
}

function loadGlossary() {
  const { data } = useSelector(state => state.global)
  return (data && data.glossary) || {}
}

function mapArticle(article) {
  if (!article) return null
  return {
    title: article.title,
    description: article.description,
    image1: normalizeMedia(article.image1),
    image2: normalizeMedia(article.image2),
    image3: normalizeMedia(article.image3),
    image4: normalizeMedia(article.image4),
  }
}

function mapDetail(item) {
  if (!item) {
    return {
      title: null,
      intro: null,
      content: null,
      description: null,
      website: null,
      logo: null,
      banner: null,
      article: null,
      article2: null,
      locations: [],
    }
  }
  return {
    title: item.title,
    intro: item.intro && item.intro.title,
    content: item.intro && item.intro.description,
    description: item.description,
    website: item.website,
    logo: (normalizeMedia(item.image) || {}).file_url,
    banner: (normalizeMedia(item.image3) || {}).file_url,
    article: mapArticle(item.article),
    article2: mapArticle(item.article2),
    locations: item.locations || [],
  }
}

function computeAdjacency(items, currentSlug) {
  const empty = { prevItem: null, nextItem: null, prevLink: "", nextLink: "" }
  if (!items || !currentSlug) return empty
  const index = items.findIndex(it => it.slug === currentSlug)
  if (index === -1) return empty
  const prev = index > 0 ? items[index - 1] : null
  const next = index < items.length - 1 ? items[index + 1] : null
  return {
    prevItem: prev ? { image: normalizeMedia(prev.image) || {}, slug: prev.slug } : null,
    nextItem: next ? { image: normalizeMedia(next.image) || {}, slug: next.slug } : null,
    prevLink: prev ? prev.slug : "",
    nextLink: next ? next.slug : "",
  }
}

function loadDetail(slug) {
  const { detail, data } = useSelector(state => state.projects)
  return {
    ...mapDetail(detail),
    ...computeAdjacency(data && data.items, slug),
  }
}

class ProjectDetails extends Component {
  render() {
    const { slug } = this.props.match.params;

    return (
      <HookWrapper slug={slug} render={(detail, glossary, locale) =>
      <>
        <MetaTags>
          <title>{detail.title}</title>
          <meta name="description" content={detail.title} />
          <meta name="keyword" content={detail.title} />
          <meta property="og:title" content={detail.title} />
        </MetaTags>
        <Header />
        <DetailsBanner image={detail.banner} />
        <div className={style.details__content}>
          <div className={style.details__inner}>
            <ContentMain logo={detail.logo}
              intro={detail.intro}
              title={detail.title}
              content={detail.content}
              website={detail.website}
              data={detail.locations}
              countloc={detail.locations.length}
              glossary={glossary}
            />
            <div className={style.content__mb80}>
              <ContentPictureText
                image={detail.article?.image1?.file_url || ''}
                title={detail.article?.title || ''}>
               {detail.article?.description || ''}
            </ContentPictureText>
            </div>
            <ContentPicture image={detail.article?.image2?.file_url || ''} />
            <ContentPicture image={detail.article?.image3?.file_url || ''} />
            <div className={style.content__m80}>
              <ContentPictureText
                image={detail.article2?.image1?.file_url || ''}
                title={detail.article2?.title || ''}>
                {detail.article2?.description || ''}
            </ContentPictureText>
            </div>
            <ContentPicture image={detail.article2?.image2?.file_url || ''} />
            <div className={style.content__mt80}>
              <ContentSidePicture
                imageLeft={detail.article2?.image3?.file_url || ''}
                imageRight={detail.article2?.image4?.file_url || ''} />
            </div>
            {
              detail.locations.length > 0 && (<MapView data={detail.locations} glossary={glossary}/>)
            }
          </div>
        </div>
        <Navbar
          type="image"
          prevLogo="/assets/hnm-logo.png"
          nextLogo="/assets/everbest-logo.png"
          prevItem={detail.prevItem}
          nextItem={detail.nextItem}
          nextLink={detail.nextLink}
          prevLink={detail.prevLink}
          glossary={glossary}
        />
        <SectionCareer locale={locale}/>
        <ButtonScroll />
      </>
       }/>
    )
  }
}

export default ProjectDetails;
